const BusinessTypes = {
  // GET informations
  GET_BUSINESS_INFORMATIONS_SUCCESS: "GET_BUSINESS_INFORMATIONS_SUCCESS",
  GET_BUSINESS_INFORMATIONS: "GET_BUSINESS_INFORMATIONS",
  // PATCH informations
  UPDATE_BUSINESS_INFORMATIONS_SUCCESS: "UPDATE_BUSINESS_INFORMATIONS_SUCCESS",
  UPDATE_BUSINESS_WITHOUT_NOTIF: "UPDATE_BUSINESS_WITHOUT_NOTIF",
  UPDATE_BUSINESS_INFORMATIONS: "UPDATE_BUSINESS_INFORMATIONS",
  // GET business users
  GET_BUSINESS_USERS_SUCCESS: "GET_BUSINESS_USERS_SUCCESS",
  GET_BUSINESS_USERS: "GET_BUSINESS_USERS",

  //ROLES
  CREATE_BUSINESS_ROLE_OLD_VERSION: "CREATE_BUSINESS_ROLE_OLD_VERSION",
  UPDATE_BUSINESS_ROLE: "UPDATE_BUSINESS_ROLE",
  DELETE_BUSINESS_ROLE: "DELETE_BUSINESS_ROLE",

  GET_ROLES: "GET_ROLES",
  GET_ROLES_SUCCESS: "GET_ROLES_SUCCESS",
  GET_ROLES_OF_USER_SUCCESS: "GET_ROLES_OF_USER_SUCCESS",
  CREATE_ROLE: "CREATE_ROLE",
  CREATE_ROLE_SUCCESS: "CREATE_ROLE_SUCCESS",
  UPDATE_ROLE: "UPDATE_ROLE",
  UPDATE_ROLE_SUCCESS: "UPDATE_ROLE_SUCCESS",
  DELETE_ROLE: "DELETE_ROLE",
  DELETE_ROLE_SUCCESS: "DELETE_ROLE_SUCCESS",

  //USERS
  CREATE_BUSINESS_USERS_SUCCESS: "CREATE_BUSINESS_USERS_SUCCESS",
  CREATE_USER: "CREATE_USER",
  UPDATE_BUSINESS_USERS_SUCCESS: "UPDATE_BUSINESS_USERS_SUCCESS",
  UPDATE_BUSINESS_USERS: "UPDATE_BUSINESS_USERS",
  DELETE_USER: "DELETE_USER",

  UPLOAD_BUSINESS_LOGO: "UPLOAD_BUSINESS_LOGO",
  UPLOAD_BUSINESS_LOGO_SUCCESS: "UPLOAD_BUSINESS_LOGO_SUCCESS",

  GET_BUSINESS_LOGO: "GET_BUSINESS_LOGO",
  GET_BUSINESS_LOGO_SUCCESS: "GET_BUSINESS_LOGO_SUCCESS",

  // Check if email address is already in the Database
  RESET_CHECKED_EMAIL: "RESET_CHECKED_EMAIL",
  SET_CHECKED_EMAIL: "SET_CHECKED_EMAIL",
  GET_ALREADY_USED_EMAIL: "GET_ALREADY_USED_EMAIL",
  GET_ALREADY_USED_EMAIL_SUCCESS: "GET_ALREADY_USED_EMAIL_SUCCESS",

  //COLOR PALETTE
  UPDATE_BUSINESS_DEFAULT_PALETTE: "UPDATE_BUSINESS_DEFAULT_PALETTE",

  // NavBar Business
  SET_LINK_NAVBAR_BUSINESS: "SET_LINK_NAVBAR_BUSINESS",
  RESET_LINK_NAVBAR_BUSINESS: "RESET_LINK_NAVBAR_BUSINESS",

  // Keycloak
  GET_USERS_KEYCLOAK: "GET_USERS_KEYCLOAK",
  SET_LOADING_KEYCLOAK: "SET_LOADING_KEYCLOAK",
  RESET_LOADING_KEYCLOAK: "RESET_LOADING_KEYCLOAK",

  // GROUP/CLIENTS
  GET_BUSINESS_GROUP: "GET_BUSINESS_GROUP",
  GET_BUSINESS_GROUP_SUCCESS: "GET_BUSINESS_GROUP_SUCCESS",
  GET_MY_GROUPS: "GET_MY_GROUPS",
  GET_MY_GROUPS_SUCCESS: "GET_MY_GROUPS_SUCCESS",
  GET_BUSINESS_GROUP_BY_ID: "GET_BUSINESS_GROUP_BY_ID",
  GET_BUSINESS_GROUP_BY_ID_SUCCESS: "GET_BUSINESS_GROUP_BY_ID_SUCCESS",
  CREATE_GROUP: "CREATE_GROUP",
  POST_BUSINESS_GROUP_SUCCESS: "POST_BUSINESS_GROUP_SUCCESS",
  PATCH_GROUP: "PATCH_GROUP",
  PATCH_GROUP_SUCCESS: "PATCH_GROUP_SUCCESS",
  DELETE_OR_ARCHIVE_GROUP: "DELETE_OR_ARCHIVE_GROUP",
  DELETE_BUSINESS_GROUP_SUCCESS: "DELETE_BUSINESS_GROUP_SUCCESS",
  ADD_USER_BUSINESS_GROUP: "ADD_USER_BUSINESS_GROUP",
  ADD_USER_BUSINESS_GROUP_SUCCESS: "ADD_USER_BUSINESS_GROUP_SUCCESS",
  DELETE_USER_ALL_GROUP: "DELETE_USER_ALL_GROUP",
  DELETE_USER_ALL_GROUP_SUCCESS: "DELETE_USER_ALL_GROUP_SUCCESS",
  CHANGE_USER_IN_GROUP: "CHANGE_USER_IN_GROUP",
  CHANGE_USER_IN_GROUP_SUCCESS: "CHANGE_USER_IN_GROUP_SUCCESS",
  UPDATE_CLIENT_LOGO: "UPDATE_CLIENT_LOGO",
  DELETE_CLIENT_LOGO: "DELETE_CLIENT_LOGO",
  SET_PRIMARY_ACTION_COLOR: "SET_PRIMARY_ACTION_COLOR",
  SET_SECONDARY_COLOR: "SET_SECONDARY_COLOR",
  SET_BANNER_COLOR: "SET_BANNER_COLOR",
  SET_SEPARATOR_COLOR: "SET_SEPARATOR_COLOR",
}

export default BusinessTypes
